/* Desktop product page: keep the (shorter) photo column on screen while the long details column scrolls.
   If the photo column is taller than the window, it scrolls until its bottom is visible, then sticks there. */
(function () {
  var media = document.querySelector('.product__media-wrapper');
  var info = document.querySelector('.product__info-wrapper');
  if (!media || !info) return;
  var mq = window.matchMedia('(min-width: 990px)');

  function headerOffset() {
    var h = document.querySelector('sticky-header, .section-header');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    return Math.max(16, Math.round(b) + 16);
  }

  function update() {
    if (!mq.matches || media.offsetHeight >= info.offsetHeight - 40) {
      media.classList.remove('bh-sticky-media');
      media.style.top = '';
      return;
    }
    var top = headerOffset();
    var fit = window.innerHeight - media.offsetHeight - 24;
    media.classList.add('bh-sticky-media');
    media.style.top = Math.min(top, fit) + 'px';
  }

  update();
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  if (window.ResizeObserver) new ResizeObserver(update).observe(media);
  setTimeout(update, 1500);
})();
